import { render, staticRenderFns } from "./DishDescription.vue?vue&type=template&id=6532d465"
import script from "./DishDescription.vue?vue&type=script&lang=js"
export * from "./DishDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports